import React, {useEffect, useState} from 'react';
import {FileInputLabel, UploadedFileLabel} from "./input.styles";

const FileInput = ({id, label,value, onChange, name, parentClassNames, accentFileName = null}) => {

    const [fileName, setFileName] = useState('value');

    useEffect(() => {
        if(value) {
            setFileName(value?.replace(/.*[\/\\]/, ''));
        } else if(accentFileName) {
            setFileName(accentFileName.replace(/.*[\/\\]/, ''));
        }
    }, [value, accentFileName])

    return (
        <div className={parentClassNames}>
            <input type='file' id={id} className='d-none' {...{value, onChange, name}}/>
            <label htmlFor={id} className='w-100 w-lg-auto'>
                {
                    value || accentFileName ?
                        <UploadedFileLabel>
                            <div className='d-flex'>
                                <i className='icon-document-text me-3' />
                                <p title={fileName} className='mb-0 text-overflow'>{fileName}</p>
                            </div>
                            <i className='icon-tick-circle'/>
                        </UploadedFileLabel>
                        :
                        <FileInputLabel>
                            {label}
                        </FileInputLabel>
                }

            </label>
        </div>
    );
};

export default FileInput;
